import { render, staticRenderFns } from "./ClientDocuments.vue?vue&type=template&id=c90bd52c&"
import script from "./ClientDocuments.vue?vue&type=script&lang=js&"
export * from "./ClientDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports